import { getPropsForOverview } from "shared/staticHelpers";
import { EN, NEWS_TYPE, EVENT_TYPE, BLOG_TYPE } from "shared/constants";
import { NewsEventsOverviewPage } from "containers/NewsEventsOverviewPage";
import { getYesterdayISOString } from "shared/formatDate";

export async function getStaticProps({ preview = false, locale }) {
  if (locale !== EN) {
    return { notFound: true };
  }

  const result = await getPropsForOverview({
    locale,
    order: "isFeatured desc, date asc, publishedAt desc",
    preview,
    query: ` && ((_type == "${EVENT_TYPE}" && date > "${getYesterdayISOString()}") || (_type == "${BLOG_TYPE}" || _type == "${NEWS_TYPE}"))`,
    type: [NEWS_TYPE, EVENT_TYPE, BLOG_TYPE],
  });

  const blogs = result.props.posts.filter(({ _type }) => _type === BLOG_TYPE);
  const events = result.props.posts.filter(({ _type }) => _type === EVENT_TYPE);
  const news = result.props.posts.filter(({ _type }) => _type === NEWS_TYPE);

  result.props = { ...result.props, blogs, events, news };

  return result;
}

const PageToExport = (props) => <NewsEventsOverviewPage {...props} />;

export default PageToExport;
